/** @format */

import template from './gb-background-panel.html';
import './gb-background-panel.scss';

export const GbBackgroundPanelComponent = {
    template,
    require: {
        gbEditTools: '^^',
    },
    controller: class GbBackgroundPanelComponent {
        constructor() {
            'ngInject';
        }

        close() {
            this.gbEditTools.closeBackgroundPanel();
        }
    },
};
